var map = {
	"./FemaleFastDE.mp3": 35086,
	"./FemaleFastEN.mp3": 60166,
	"./FemaleFastES.mp3": 11287,
	"./FemaleFastFR.mp3": 81519,
	"./FemaleFastIT.mp3": 14816,
	"./FemaleMediumDE.mp3": 84905,
	"./FemaleMediumEN.mp3": 84369,
	"./FemaleMediumES.mp3": 92200,
	"./FemaleMediumFR.mp3": 52700,
	"./FemaleMediumIT.mp3": 90895,
	"./FemaleSlowDE.mp3": 42179,
	"./FemaleSlowEN.mp3": 3319,
	"./FemaleSlowES.mp3": 82822,
	"./FemaleSlowFR.mp3": 61486,
	"./FemaleSlowIT.mp3": 77721,
	"./MaleFastDE.mp3": 4521,
	"./MaleFastEN.mp3": 8433,
	"./MaleFastES.mp3": 11816,
	"./MaleFastFR.mp3": 45916,
	"./MaleFastIT.mp3": 26639,
	"./MaleMediumDE.mp3": 56142,
	"./MaleMediumEN.mp3": 2022,
	"./MaleMediumES.mp3": 6167,
	"./MaleMediumFR.mp3": 37871,
	"./MaleMediumIT.mp3": 24192,
	"./MaleSlowDE.mp3": 90164,
	"./MaleSlowEN.mp3": 49984,
	"./MaleSlowES.mp3": 69977,
	"./MaleSlowFR.mp3": 52677,
	"./MaleSlowIT.mp3": 14558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84541;